import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { QuickRepliesElementsConfiguration } from '../../models';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Apple Messages for Business
 */
export class BusinessChatService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 13;
  }
  getTypeString(): string {
    return SiteTypeEnum.AppleBusinessChat;
  }
  getAllTasksTypes(): number[] {
    return [36];
  }
  getPrivateTaskTypes(): number[] {
    return [36];
  }

  canHaveSurveys(): boolean {
    return true;
  }

  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    return {
      maxAnswerNb: 20,
      answerLabelMaxLength: 40,
      questionBox: {
        minAnswers: 2,
        maxAnswers: 5,
      },
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: false, // disabled for now, as question boxes are converted to list pickers for bzc
        hasImageControl: false,
      },
      sendTextAfterButtonChoice: true,
      canSendVideo: true,
    };
  }
  getTaskTypeString(taskType: number): string {
    const mapping = {
      36: 'business-chat/msg',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      36: 'business-chat-msg',
    };
    return mapping[taskType];
  }
}
